export default "__VITE_ASSET__CmYJOxi9__"